export { default } from './ForgotSuccessPage'
